import { useNavigate } from 'react-router-dom';
import { http } from '@/api/client';
import { keys, useInvalidate, useReadings } from '@/api/hooks';
import { Empty, Skeleton } from '@/components/ui';
import { Icon } from '@/components/Icon';

export function HistoryScreen() {
  const nav = useNavigate();
  const { data } = useReadings();
  const invalidate = useInvalidate();

  const remove = async (id: string) => { await http.del(`/readings/${id}`); void invalidate(keys.readings); };

  return (
    <div className="screen">
      <div className="topbar"><button className="back" onClick={() => nav(-1)}><Icon name="back" size={18} />Назад</button><div className="title">История</div><span style={{ width: 60 }} /></div>
      <div className="stack">
        {!data && <Skeleton h={70} />}
        {data && data.items.length === 0 && <Empty icon="🌙" text="История пуста" action={<button className="btn ghost sm" style={{ marginTop: 10 }} onClick={() => nav('/')}>Сделать расклад</button>} />}
        {data?.items.map((r) => (
          <div key={r.id} className="card hist" onClick={() => nav(`/reading/${r.id}`)}>
            <div className="mini">{r.cards.slice(0, 3).map((c) => <span key={c.key} style={c.imageUrl ? { backgroundImage: `url(${c.imageUrl})` } : undefined}>{c.imageUrl ? '' : c.symbol}</span>)}</div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{r.question}</div>
              <div className="dim">{new Date(r.createdAt).toLocaleString('ru-RU', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}</div>
            </div>
            <button className="btn ghost sm icon-btn" onClick={(e) => { e.stopPropagation(); void remove(r.id); }} aria-label="Удалить"><Icon name="trash" size={16} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
